import { DataBean } from "../DataBean";

export class AddRawMaterialRequest extends DataBean {


    public async addRawMaterialRequest(idProductionOrder:any,productionOrderDate:any,media:any,mediaContext:any,description:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.productionorders.RawMaterialRequest_addRawMaterialRequest_Number_java.util.Date_String_String_String_Number", [idProductionOrder,productionOrderDate,media,mediaContext,description,idEmployee]);
    }


 
}